<table 
  *ngIf="dataSet"
  mat-table [dataSource]="dataSet"
  class="report-pickup__table">
  
  <ng-container
    *ngFor="let column of tableHeadersData"
    [matColumnDef]="column.columnDef"
  >
    <th mat-header-cell *matHeaderCellDef class="report-table-header sticky-header">{{ column.header }}</th>
    <td 
      mat-cell
      *matCellDef="let element"
      class="report-table-data">

        @if (column.columnDef !== 'status') {
          <span class="report-table-text-column">
            {{ element[column.columnDef] }}
          </span>
        }

        @else {
          @if (element[column.columnDef] === 'completed') {
            <div class="status-btn">
              <app-button 
                [loading]="element.downloading"
                (buttonEvent)="onButtonEvent(element, 'download')"
                [classNames]="newDate > element.expirationTime?'disabled':'success'" 
                [disabled]="newDate > element.expirationTime"
                [matTooltip]="newDate > element.expirationTime? 'Report is no longer available for download since it’s passed the expiration date': ''"
                matTooltipPosition="left">
                <mat-icon class="material-symbols-outlined" aria-label="Download Report">
                  <span class="material-symbols-outlined">
                    download
                  </span>
                </mat-icon>
              </app-button>
              <app-button (buttonEvent)="onButtonEvent(element, 'show')" [classNames]="'success'" aria-label="Report Details">
                <mat-icon class="material-symbols-outlined">
                  <span class="material-symbols-outlined">
                    info
                  </span>
                </mat-icon>
              </app-button>
              <app-button
               
                (buttonEvent)="onButtonEvent(element, 'delete')"
                [classNames]="'error'">
                <mat-icon class="material-symbols-outlined" aria-label="Delete Report">
                  <span class="material-symbols-outlined">
                    delete_forever
                  </span>
                </mat-icon>
              </app-button>
            </div>  
          }

          @else if (element[column.columnDef] === 'failed') {
            <app-button
              [disabled]="true"
              [block]="true"
              [classNames]="'error'">
              {{ element[column.columnDef] }}
            </app-button>
          }
          
          @else {
            <app-button
              [disabled]="true"
              [block]="true"
              [classNames]="'pending'">
              {{ element[column.columnDef] }}
            </app-button>
          }
        }
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    [ngClass]="{ 'deleted': row.status === 'deleted'}"
    mat-row
    *matRowDef="let row; columns: displayedColumns">
  </tr>
</table>
